import { Button } from "@mui/material";
import "./CookieConsentModal.css";
import CustomModal from "./CustomModal";
import { ConsentStatus } from "../utils/cookieConsent";

interface CookieConsentModalProps {
  open: boolean;
  onAccept: () => void;
  onDecline: () => void;
  onClose?: () => void;
  consentStatus?: ConsentStatus;
  showCurrentStatus?: boolean;
}

const CookieConsentModal = ({
  open,
  onAccept,
  onDecline,
  onClose,
  consentStatus = ConsentStatus.PENDING,
  showCurrentStatus = false,
}: CookieConsentModalProps) => {
  const hasAcceptedCookies = consentStatus === ConsentStatus.ACCEPTED;
  const hasDeclinedCookies = consentStatus === ConsentStatus.DECLINED;

  return (
    <CustomModal open={open} onClose={onClose} size="medium">
      <div className="cookie-consent-modal">
        <div className="cookie-consent-modal__content">
          <h2 className="cookie-consent-modal__title">
            Utilisation des cookies
          </h2>

          <div className="cookie-consent-modal__text">
            <p>
              Nous utilisons des cookies pour améliorer votre expérience de
              navigation, analyser l'utilisation du site et comprendre d'où
              viennent nos visiteurs. Ces cookies nous permettent de mesurer
              l'audience et d'optimiser notre contenu médical pour mieux vous
              servir.
            </p>

            <p>
              En continuant à utiliser ce site, vous acceptez notre utilisation
              des cookies. Si vous préférez ne pas être suivi, vous pouvez{" "}
              <span
                className="cookie-consent-modal__decline-link"
                onClick={onDecline}
              >
                refuser
              </span>{" "}
              l'utilisation des cookies.
            </p>

            {showCurrentStatus && (
              <>
                <p>
                  Ce choix s'applique uniquement à cet appareil et à ce
                  navigateur.
                </p>
                <p className="cookie-consent-modal__status">
                  Statut actuel :{" "}
                  {hasAcceptedCookies
                    ? "suivi activé"
                    : hasDeclinedCookies
                    ? "suivi désactivé"
                    : "aucun choix enregistré"}
                </p>
              </>
            )}
          </div>

          <div className="cookie-consent-modal__button-container">
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={onAccept}
              disabled={showCurrentStatus && hasAcceptedCookies}
              className="cookie-consent-modal__accept-button"
            >
              {hasAcceptedCookies ? "Cookies acceptés" : "Accepter les cookies"}
            </Button>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default CookieConsentModal;
